import fetchWrapper from "@/api/fetch-wrapper";

export const getAreaPurposes = () => {
    const query = `/calculators/strakhovanie-imushchestva-yuridicheskikh-lits/ajax/purposeSpaces.php`;
    
    return fetchWrapper.get(query);
}